var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 5C8.69377 5 7.58253 5.83481 7.1707 7H6.76538L6.26538 9H7.1707C7.58253 10.1652 8.69377 11 9.99999 11H10.25V5H9.99999Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 11H11.75V5H19C20.6569 5 22 6.34315 22 8C22 9.2419 21.2454 10.3076 20.1697 10.7634L21.9571 18.8069C21.9856 18.9352 22 19.0663 22 19.1978C22 20.1931 21.1931 21 20.1978 21H15C14.4477 21 14 20.5523 14 20C14 19.4477 14.4477 19 15 19H17L16.0556 14.75H15C13.4812 14.75 12.25 13.5188 12.25 12V11ZM13.75 11V12C13.75 12.6904 14.3096 13.25 15 13.25H15.7222L15.2222 11H13.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.73461 7H3L2 8L3 9H3.23461L3.73461 7Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26538 9H5.2346L5.7346 7H4.76538L4.26538 9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrill);
export default __webpack_public_path__ + "static/media/drill.04181a06e05d92a35054d78a50549801.svg";
export { ForwardRef as ReactComponent };